import { Modal } from 'almanac-ui/Modal'
import { Field as BaseField } from 'components/Wizards/Field/Field'
import { FilePathFormikField } from 'components/Wizards/FilePathFormikField/FilePathFormikField'
import { Formik } from 'formik'
import { object } from 'yup'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project as projectSchema } from 'components/Wizards/schemas/shared/project'
import { AlmanacFile } from 'types'

export interface Location {
  filename: string
  project: any
}

interface Props {
  onConfirm: (location: Location) => any
  onCancel: () => any
  project: AlmanacFile
}

export const LocationModal = ({ onCancel, onConfirm, project }: Props) => (
  <Formik
    initialValues={{ project: project, filename: '' }}
    validationSchema={object({ filename, project: projectSchema })}
    onSubmit={(values) => {
      onConfirm(values)
    }}
  >
    {({ submitForm, isSubmitting }) => (
      <Modal.Root size="sm" aria-labelledby="modal-header">
        <Modal.Header />
        <Modal.Content>
          <BaseField label="Name your doc and select a location" isRequired id="modal-header">
            <FilePathFormikField />
          </BaseField>
        </Modal.Content>
        <Modal.Footer>
          <Modal.FooterContent slot="left">
            <Modal.FooterButton size="lg" variant="tertiary" onPress={onCancel}>
              Back
            </Modal.FooterButton>
          </Modal.FooterContent>
          <Modal.FooterContent slot="right">
            <Modal.FooterButton size="lg" onPress={submitForm} isDisabled={isSubmitting}>
              Generate New Doc
            </Modal.FooterButton>
          </Modal.FooterContent>
        </Modal.Footer>
      </Modal.Root>
    )}
  </Formik>
)
